import React from 'react';
import { Calendar } from 'primereact/calendar';

const DateRangeFilter = ({ dateBegin, setDateBegin, dateEnd, setDateEnd, aggregation }) => {
    const getCalendarSettings = () => {
        switch(aggregation) {
            case 'year':
                return {
                    view: 'year',
                    dateFormat: 'yy',
                    placeholder: 'Année'
                };
            case 'month':
                return {
                    view: 'month',
                    dateFormat: 'mm/yy',
                    placeholder: 'Mois/Année'
                };
            default:
                return {
                    view: 'date',
                    dateFormat: 'dd/mm/yy',
                    placeholder: 'Date'
                };
        }
    };

    const settings = getCalendarSettings();

    const formatDateForAPI = (date) => {
        if (!date) return null;
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const parseAPIDate = (dateString) => {
        if (!dateString) return null;
        const [year, month, day] = dateString.split('-');
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    };

    return (
        <div className="flex gap-2 mt-2">
            <div className="card flex justify-content-center">
                <Calendar
                    value={parseAPIDate(dateBegin)}
                    onChange={(e) => {
                        const formattedDate = formatDateForAPI(e.value);
                        console.log('Date début formatée:', formattedDate);
                        setDateBegin(formattedDate);
                    }}
                    view={settings.view}
                    dateFormat={settings.dateFormat}
                    placeholder={`${settings.placeholder} début`}
                    showIcon
                    className="w-full md:w-20rem"
                    showButtonBar
                    
                />
            </div>
            <div className="card flex justify-content-center">
              <Calendar
                    value={parseAPIDate(dateEnd)}
                    onChange={(e) => {
                        const formattedDate = formatDateForAPI(e.value);
                        console.log('Date fin formatée:', formattedDate);
                        setDateEnd(formattedDate);
                    }}
                    view={settings.view}
                    dateFormat={settings.dateFormat}
                    placeholder={`${settings.placeholder} fin`}
                    showIcon
                    className="w-full md:w-20rem"
                    minDate={parseAPIDate(dateBegin)}
                    showButtonBar
                   
                />
            </div> 
        </div>
    );
};

export default DateRangeFilter; 